export const generatedModelArtifactBundle = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-generated-model-artifact-bundle",
  "promotionRule": "No model output can become a verified business or science claim without source records, units, uncertainty, reproducible query metadata, runtime evidence, and independent validation when applicable.",
  "manifest": {
    "generatedAt": "2026-06-19T16:05:00Z",
    "mode": "deterministic-reviewed-snapshots",
    "rule": "The app may display these records without live API access, but refresh tools must preserve query, source, units, and tolerance metadata.",
    "sources": [
      "horizons-api",
      "sbdb-api",
      "cad-api",
      "spice-gf",
      "orekit",
      "gmat"
    ]
  },
  "sourceRegistryHash": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
  "assumptionRegistryHash": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11",
  "scenarioNotebookHash": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f",
  "artifactCount": 7,
  "blockedArtifactCount": 7,
  "generatedArtifacts": [
    {
      "id": "artifact-horizons-geometry-v1",
      "name": "Horizons Earth/Mercury geometry snapshot",
      "domain": "Ephemeris",
      "modelType": "official-api-snapshot",
      "claimState": "source-backed",
      "runtimeStatus": "deterministic-snapshot",
      "sourceIds": [
        "horizons-api",
        "iau-sofa"
      ],
      "query": "COMMAND='199', CENTER='500@399', EPHEM_TYPE='OBSERVER', TIME_TYPE='TDB'",
      "units": [
        "TDB",
        "AU",
        "km",
        "minutes",
        "degrees"
      ],
      "uncertainty": "Declared table tolerance plus local formula tolerance.",
      "validation": "Light-time and AU/km consistency tests pass.",
      "nextAction": "Generate a live refresh artifact and preserve response hash.",
      "sourceRecords": [
        {
          "sourceId": "horizons-api",
          "title": "JPL Horizons API",
          "trust": "primary",
          "url": "https://ssd-api.jpl.nasa.gov/doc/horizons.html",
          "recordHash": "fnv1a32-9335c241",
          "queryPolicy": "Full Horizons query string and response timestamp required.",
          "units": [
            "TDB",
            "AU",
            "km",
            "minutes",
            "degrees"
          ],
          "uncertaintyMode": "API table tolerance plus downstream numeric tolerance."
        },
        {
          "sourceId": "iau-sofa",
          "title": "Standards of Fundamental Astronomy",
          "trust": "primary",
          "url": "https://www.iausofa.org/",
          "recordHash": "fnv1a32-2a854c84",
          "queryPolicy": "Routine/version reference and transformation chain required.",
          "units": [
            "time scales",
            "reference frames"
          ],
          "uncertaintyMode": "Standards conformance and transform precision."
        }
      ],
      "snapshotEvidence": [
        {
          "id": "horizons-mercury-earth-2025-05-17",
          "sourceId": "horizons-api",
          "query": "COMMAND='199', CENTER='500@399', EPHEM_TYPE='OBSERVER', TIME_TYPE='TDB', START_TIME='2025-May-17', STOP_TIME='2025-May-18', STEP_SIZE='1 d'",
          "timeScale": "TDB",
          "tolerance": {
            "distanceAu": 0.02,
            "lightTimeMinutes": 0.25,
            "elongationDeg": 0.75
          },
          "hash": "sha256-24ab1712ec21932fe28ca59b316b04b534e0e6ef44ac8b35214b0067ae8e1e79"
        },
        {
          "id": "horizons-mercury-clear-window-2025-08-28",
          "sourceId": "horizons-api",
          "query": "COMMAND='199', CENTER='500@399', EPHEM_TYPE='OBSERVER', TIME_TYPE='TDB', START_TIME='2025-Aug-28', STOP_TIME='2025-Aug-29', STEP_SIZE='1 d'",
          "timeScale": "TDB",
          "tolerance": {
            "distanceAu": 0.03,
            "lightTimeMinutes": 0.35,
            "elongationDeg": 1
          },
          "hash": "sha256-8ae4c04c7bf7f99e77cddd8b4d1db323c0277c41ebc2e7b66f4176e36c37a934"
        }
      ],
      "readinessScore": 78.00000000000001,
      "promotionAllowed": false,
      "contractHash": "fnv1a32-84000384",
      "generatedHash": "sha256-996cdbf9f58f4c0a12c65c3d9f3a0d03e9f41ebc05479888800a5b3dbfa8ee0b"
    },
    {
      "id": "artifact-sbdb-cad-screen-v1",
      "name": "SBDB/CAD small-body candidate screen",
      "domain": "Feedstock",
      "modelType": "official-api-screen",
      "claimState": "source-backed-blocked",
      "runtimeStatus": "deterministic-snapshot",
      "sourceIds": [
        "sbdb-api",
        "cad-api"
      ],
      "query": "CAD date/distance screen plus SBDB physical-property lookup.",
      "units": [
        "AU",
        "km/s",
        "diameter confidence",
        "orbit condition code"
      ],
      "uncertainty": "Resource composition is unknown without taxonomy, spectra, or mission data.",
      "validation": "Tests prevent close-approach geometry from implying composition.",
      "nextAction": "Attach candidate-specific taxonomy/spectra/PDS records before promotion.",
      "sourceRecords": [
        {
          "sourceId": "sbdb-api",
          "title": "JPL Small-Body Database API",
          "trust": "primary",
          "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
          "recordHash": "fnv1a32-93c0fe91",
          "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
          "units": [
            "AU",
            "km/s",
            "H",
            "diameter",
            "orbit condition code"
          ],
          "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
        },
        {
          "sourceId": "cad-api",
          "title": "SBDB Close Approach Data API",
          "trust": "primary",
          "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
          "recordHash": "fnv1a32-ba0c45bb",
          "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
          "units": [
            "AU",
            "km/s",
            "date"
          ],
          "uncertaintyMode": "Nominal approach values with orbit-solution caveats."
        }
      ],
      "snapshotEvidence": [
        {
          "id": "cad-screen-apollo-low-vinf-demo",
          "sourceIds": [
            "sbdb-api",
            "cad-api"
          ],
          "query": "cad.api?dist-max=0.2&date-min=2026-01-01&date-max=2036-01-01&sort=date&diameter=true",
          "status": "unpromoted-source-backed-screen",
          "resourceRule": "Composition remains unknown unless taxonomy, spectra, or mission data is attached.",
          "hash": "sha256-63e4802e1b3b6026a69e47fd7c5631e056d9586076ed62a64671e66f6b8e0362"
        },
        {
          "id": "cad-screen-high-frequency-demo",
          "sourceIds": [
            "sbdb-api",
            "cad-api"
          ],
          "query": "cad.api?dist-max=0.1&date-min=2026-01-01&date-max=2046-01-01&sort=dist&diameter=true",
          "status": "unpromoted-source-backed-screen",
          "resourceRule": "High approach cadence does not imply feedstock value; resource confidence remains low until sourced.",
          "hash": "sha256-d182ab4933ea42631feefa5c3eda3294b327b69740dd71733caca8de43fd34bd"
        }
      ],
      "readinessScore": 70,
      "promotionAllowed": false,
      "contractHash": "fnv1a32-38332261",
      "generatedHash": "sha256-fb7b5d1d0fe4880d0b423a0cd29e82c4b0d5f2d1f5c1a07cfb39d6ac36d89d53"
    },
    {
      "id": "artifact-spice-gf-windows-v1",
      "name": "SPICE Geometry Finder event-window contract",
      "domain": "Event windows",
      "modelType": "geometry-event-window",
      "claimState": "adapter-contract",
      "runtimeStatus": "adapter-fixture",
      "sourceIds": [
        "spice-gf"
      ],
      "query": "Kernel set plus angular-separation/occultation constraints.",
      "units": [
        "TDB/ET",
        "event windows",
        "degrees",
        "km"
      ],
      "uncertainty": "Kernel coverage and GF constraint tolerance required.",
      "validation": "Boundary contract exists; runtime kernel-hash artifact not generated yet.",
      "nextAction": "Run SPICE with recorded kernels and store event-window hash.",
      "sourceRecords": [
        {
          "sourceId": "spice-gf",
          "title": "SPICE Geometry Finder",
          "trust": "primary",
          "url": "https://naif.jpl.nasa.gov/pub/naif/toolkit_docs/C/req/gf.html",
          "recordHash": "fnv1a32-97d74c96",
          "queryPolicy": "Kernel set, target/observer/constraint, tolerance, and generated window hash required.",
          "units": [
            "TDB/ET",
            "km",
            "degrees",
            "event windows"
          ],
          "uncertaintyMode": "Kernel coverage plus geometric tolerance."
        }
      ],
      "snapshotEvidence": [
        {
          "id": "spice-gf-mercury-conjunction-demo-2025",
          "sourceId": "spice-gf",
          "kernelSet": "DE440-family planetary SPK + leapseconds kernel, adapter boundary only",
          "status": "adapter-fixture",
          "caveat": "This fixture validates the app boundary. Operational claims require a generated SPICE run artifact with kernel hashes.",
          "hash": "sha256-759ce9a2bedd3c1959dcd8ad963916fb91be0596592bf18d9a281b410351a84b"
        }
      ],
      "readinessScore": 57.300000000000004,
      "promotionAllowed": false,
      "contractHash": "fnv1a32-6f7f670c",
      "generatedHash": "sha256-3c5e391540936642e08bc6cb1129730c85730e6d0e17bf0e0987667af78dc38b"
    },
    {
      "id": "artifact-trajectory-sidecar-v1",
      "name": "Orekit/GMAT/Tudat trajectory validation sidecar",
      "domain": "Trajectory",
      "modelType": "cross-tool-trajectory-validation",
      "claimState": "blocked",
      "runtimeStatus": "contract-ready-no-runtime-artifact",
      "sourceIds": [
        "orekit",
        "gmat",
        "tudat",
        "openmdao",
        "dymos"
      ],
      "query": "Scenario epoch, force model, transfer constraints, optimizer settings.",
      "units": [
        "km",
        "km/s",
        "seconds",
        "constraint residuals"
      ],
      "uncertainty": "Requires independent propagation residuals and model-configuration trace.",
      "validation": "Artifact schema exists; no runtime comparison generated yet.",
      "nextAction": "Create offline sidecar job and compare at least one transfer window.",
      "sourceRecords": [
        {
          "sourceId": "orekit",
          "title": "Orekit",
          "trust": "open-source",
          "url": "https://www.orekit.org/",
          "recordHash": "fnv1a32-88a8d672",
          "queryPolicy": "Tool version, data context, frames, force model, and checksums required.",
          "units": [
            "frames",
            "time scales",
            "state vectors",
            "events"
          ],
          "uncertaintyMode": "Model configuration and independent comparison residuals."
        },
        {
          "sourceId": "gmat",
          "title": "General Mission Analysis Tool",
          "trust": "primary",
          "url": "https://software.nasa.gov/software/GSC-17177-1",
          "recordHash": "fnv1a32-3743e565",
          "queryPolicy": "GMAT script hash, version, force model, optimizer, and run summary required.",
          "units": [
            "km",
            "km/s",
            "seconds",
            "constraints"
          ],
          "uncertaintyMode": "Constraint residuals and cross-tool comparison."
        },
        {
          "sourceId": "tudat",
          "title": "Tudat Space / TudatPy",
          "trust": "open-source",
          "url": "https://docs.tudat.space/en/latest/",
          "recordHash": "fnv1a32-c238f1d2",
          "queryPolicy": "Tool version, body settings, integrator, propagator, and output hashes required.",
          "units": [
            "state vectors",
            "epochs",
            "frames",
            "residuals"
          ],
          "uncertaintyMode": "Integrator settings, model configuration, and cross-tool residual bounds."
        },
        {
          "sourceId": "openmdao",
          "title": "OpenMDAO",
          "trust": "primary",
          "url": "https://openmdao.org/",
          "recordHash": "fnv1a32-9ef7d3cb",
          "queryPolicy": "Problem definition, design variables, constraints, objective, and seed required.",
          "units": [
            "dimensionless",
            "scenario-specific"
          ],
          "uncertaintyMode": "Sensitivity and optimizer-convergence metadata."
        },
        {
          "sourceId": "dymos",
          "title": "Dymos",
          "trust": "open-source",
          "url": "https://openmdao.github.io/dymos/",
          "recordHash": "fnv1a32-31dbd31c",
          "queryPolicy": "Problem definition, transcription, optimizer, constraints, objective, and run seed required.",
          "units": [
            "states",
            "controls",
            "constraints",
            "objective values"
          ],
          "uncertaintyMode": "Convergence status, sensitivity, and collocation residuals."
        }
      ],
      "snapshotEvidence": [
        {
          "id": "orekit-adapter-contract-v0",
          "sourceId": "orekit",
          "role": "Independent propagation/event-check adapter contract",
          "requiredFields": [
            "toolVersion",
            "dataContext",
            "frames",
            "timeScale",
            "kernelOrEphemeris",
            "runAt",
            "scenarioId",
            "events",
            "checksums"
          ],
          "status": "contract-ready-no-runtime-artifact",
          "hash": "sha256-f4bfba01dc17d2c437ca30d2da67d7db6a40199cc4c944260cb21bbe26d02fe0"
        },
        {
          "id": "gmat-transfer-contract-v0",
          "sourceId": "gmat",
          "role": "Transfer and mission-design validation artifact contract",
          "requiredFields": [
            "gmatVersion",
            "scriptHash",
            "forceModel",
            "optimizer",
            "epoch",
            "trajectorySummary",
            "constraintSummary",
            "checksums"
          ],
          "status": "contract-ready-no-runtime-artifact",
          "hash": "sha256-7bf968dd78a7084b11964eb52bccdce44f26c64a0176671b061a2034e3342596"
        }
      ],
      "readinessScore": 44.300000000000004,
      "promotionAllowed": false,
      "contractHash": "fnv1a32-0fa3828b",
      "generatedHash": "sha256-231710b94f12e3043cd9320cab908c5aee411da6b0ae20b3d7be604a10e729d3"
    },
    {
      "id": "artifact-space-environment-v1",
      "name": "Space environment and radiation evidence contract",
      "domain": "Space environment",
      "modelType": "space-weather-environment-screen",
      "claimState": "hypothesis",
      "runtimeStatus": "design-contract",
      "sourceIds": [
        "nasa-spdf",
        "nasa-ccmc",
        "noaa-swpc"
      ],
      "query": "Heliophysics datasets, space-weather model runs, and forecast/archive products.",
      "units": [
        "particle flux",
        "Kp/Ap",
        "F10.7",
        "radiation/environment indices"
      ],
      "uncertainty": "High until mission/site-specific time ranges, shielding assumptions, and model validation records are attached.",
      "validation": "No space-environment artifact is generated yet.",
      "nextAction": "Add SPDF/CCMC/SWPC adapters for site-specific radiation and solar-weather assumptions.",
      "sourceRecords": [
        {
          "sourceId": "nasa-spdf",
          "title": "NASA Space Physics Data Facility",
          "trust": "primary",
          "url": "https://spdf.gsfc.nasa.gov/",
          "recordHash": "fnv1a32-05f4400c",
          "queryPolicy": "Dataset id, variables, time range, cadence, and retrieval hash required.",
          "units": [
            "CDF",
            "mission-specific plasma/radiation fields"
          ],
          "uncertaintyMode": "Instrument calibration, cadence, and archive-version caveats."
        },
        {
          "sourceId": "nasa-ccmc",
          "title": "Community Coordinated Modeling Center",
          "trust": "primary",
          "url": "https://ccmc.gsfc.nasa.gov/",
          "recordHash": "fnv1a32-1a450de5",
          "queryPolicy": "Model, run id, inputs, version, and output hash required.",
          "units": [
            "model-specific"
          ],
          "uncertaintyMode": "Model validation state, run configuration, and uncertainty bounds."
        },
        {
          "sourceId": "noaa-swpc",
          "title": "NOAA Space Weather Prediction Center Products and Data",
          "trust": "primary",
          "url": "https://www.spaceweather.gov/products-and-data",
          "recordHash": "fnv1a32-dbbbdd09",
          "queryPolicy": "Product id, issue time, forecast horizon, and archive link required.",
          "units": [
            "Kp",
            "Ap",
            "F10.7",
            "particle flux",
            "alerts"
          ],
          "uncertaintyMode": "Forecast horizon and product-specific verification notes."
        }
      ],
      "snapshotEvidence": [],
      "readinessScore": 31.900000000000002,
      "promotionAllowed": false,
      "contractHash": "fnv1a32-2d8fc05a",
      "generatedHash": "sha256-52de069809b7f001070915864549a732b2eb32a183c4bb8b28ff54ac5c272c89"
    },
    {
      "id": "artifact-materials-process-v1",
      "name": "Materials/process physics module contract",
      "domain": "Manufacturing",
      "modelType": "thermal-material-process-fit",
      "claimState": "hypothesis",
      "runtimeStatus": "design-contract",
      "sourceIds": [
        "nist-codata",
        "nist-chemistry-webbook",
        "materials-project",
        "cantera",
        "moose-framework",
        "openfoam",
        "pds",
        "openmdao"
      ],
      "query": "Material property source, thermal environment, process window, energy balance.",
      "units": [
        "K",
        "W/m^2",
        "kg",
        "kWh",
        "stress/temperature where sourced"
      ],
      "uncertainty": "High until NIST/materials/process data adapters are attached.",
      "validation": "No physics-grade material model is generated yet.",
      "nextAction": "Add NIST/Materials Project/Cantera/MOOSE/OpenFOAM artifact adapters.",
      "sourceRecords": [
        {
          "sourceId": "nist-codata",
          "title": "2022 CODATA Fundamental Physical Constants",
          "trust": "primary",
          "url": "https://physics.nist.gov/cuu/Constants/Table/allascii.txt",
          "recordHash": "fnv1a32-333cff52",
          "queryPolicy": "Constants release and exact constant identifiers required.",
          "units": [
            "SI"
          ],
          "uncertaintyMode": "CODATA uncertainty or exact-SI status."
        },
        {
          "sourceId": "nist-chemistry-webbook",
          "title": "NIST Chemistry WebBook SRD 69",
          "trust": "primary",
          "url": "https://webbook.nist.gov/chemistry/",
          "recordHash": "fnv1a32-d9ac987b",
          "queryPolicy": "Species identifier, property table, units, citation, and access date required.",
          "units": [
            "thermochemical",
            "thermophysical",
            "spectral"
          ],
          "uncertaintyMode": "NIST data notes, property method, and cited evaluation caveats."
        },
        {
          "sourceId": "materials-project",
          "title": "Materials Project API",
          "trust": "primary",
          "url": "https://docs.materialsproject.org/downloading-data/using-the-api",
          "recordHash": "fnv1a32-c46b2daa",
          "queryPolicy": "mp-id, fields, API version/client, method metadata, and retrieval hash required.",
          "units": [
            "material-specific"
          ],
          "uncertaintyMode": "DFT/method limitations, provenance, and contributed-data caveats."
        },
        {
          "sourceId": "cantera",
          "title": "Cantera",
          "trust": "open-source",
          "url": "https://cantera.org/",
          "recordHash": "fnv1a32-883bdb34",
          "queryPolicy": "Mechanism file, tool version, inputs, outputs, and mechanism hash required.",
          "units": [
            "species",
            "reactions",
            "transport",
            "temperature",
            "pressure"
          ],
          "uncertaintyMode": "Mechanism validity range and solver tolerance."
        },
        {
          "sourceId": "moose-framework",
          "title": "MOOSE Framework",
          "trust": "primary",
          "url": "https://mooseframework.inl.gov/",
          "recordHash": "fnv1a32-a9482599",
          "queryPolicy": "Input file, application/version, mesh hash, material data, and output hash required.",
          "units": [
            "mesh",
            "material properties",
            "PDE residuals",
            "solver tolerances"
          ],
          "uncertaintyMode": "Discretization, mesh convergence, solver residuals, and material uncertainty."
        },
        {
          "sourceId": "openfoam",
          "title": "OpenFOAM",
          "trust": "open-source",
          "url": "https://www.openfoam.com/",
          "recordHash": "fnv1a32-124056ab",
          "queryPolicy": "Case directory hash, solver/version, mesh, boundary conditions, and result hash required.",
          "units": [
            "mesh",
            "fields",
            "boundary conditions",
            "solver residuals"
          ],
          "uncertaintyMode": "Mesh convergence, turbulence model, chemistry model, and boundary-condition uncertainty."
        },
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "trust": "primary",
          "url": "https://pds.nasa.gov/datasearch/data-search/",
          "recordHash": "fnv1a32-7c477cc2",
          "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
          "units": [
            "instrument-specific"
          ],
          "uncertaintyMode": "Instrument/product calibration metadata."
        },
        {
          "sourceId": "openmdao",
          "title": "OpenMDAO",
          "trust": "primary",
          "url": "https://openmdao.org/",
          "recordHash": "fnv1a32-9ef7d3cb",
          "queryPolicy": "Problem definition, design variables, constraints, objective, and seed required.",
          "units": [
            "dimensionless",
            "scenario-specific"
          ],
          "uncertaintyMode": "Sensitivity and optimizer-convergence metadata."
        }
      ],
      "snapshotEvidence": [],
      "readinessScore": 34.2,
      "promotionAllowed": false,
      "contractHash": "fnv1a32-3b863280",
      "generatedHash": "sha256-0ea8cba3f384e4f4c51fd58a414bdb5dd124be01b5f9a6bf319ccc7aba308d83"
    },
    {
      "id": "artifact-economics-uncertainty-v1",
      "name": "Economics and Monte Carlo frontier artifact",
      "domain": "Business model",
      "modelType": "portfolio-sensitivity-model",
      "claimState": "model-derived-unvalidated",
      "runtimeStatus": "deterministic-generated-monte-carlo",
      "sourceIds": [
        "spacex-rideshare",
        "nasa-clps",
        "nasa-cost-estimating-handbook",
        "nasa-se-handbook",
        "usaspending",
        "sec-edgar"
      ],
      "query": "Seeded planning ranges for launch price, capital, mass-to-site, horizon, and demand-readiness proxy.",
      "units": [
        "USD",
        "kg",
        "tonnes",
        "years",
        "probability"
      ],
      "uncertainty": "High until dated cost ranges and source-backed market assumptions are attached.",
      "validation": "Generated economics-frontier artifact records seeded samples, scenario rank stability, funding coverage, and blockers.",
      "nextAction": "Attach dated launch-cost, capex, opex, and market-source records before promotion.",
      "sourceRecords": [
        {
          "sourceId": "spacex-rideshare",
          "title": "SpaceX Rideshare Program",
          "trust": "commercial-primary",
          "url": "https://www.spacex.com/rideshare/",
          "recordHash": "fnv1a32-86aacff8",
          "queryPolicy": "Capture provider page, access timestamp, price table text, destination/orbit class, and terms caveats before use.",
          "units": [
            "USD",
            "kg",
            "orbit class",
            "payload envelope"
          ],
          "uncertaintyMode": "Commercial list price caveats, mission-specific integration costs, schedule, destination, and contract terms."
        },
        {
          "sourceId": "nasa-clps",
          "title": "Commercial Lunar Payload Services",
          "trust": "primary",
          "url": "https://www.nasa.gov/commercial-lunar-payload-services/",
          "recordHash": "fnv1a32-7d151be6",
          "queryPolicy": "Capture NASA program page, date, task-order references, provider, payload mass/context, and award amount where available.",
          "units": [
            "USD",
            "payload count",
            "delivery count",
            "contract envelope"
          ],
          "uncertaintyMode": "Task-order scope, modifications, mission risk, provider performance, and payload-specific services."
        },
        {
          "sourceId": "nasa-cost-estimating-handbook",
          "title": "NASA Cost Estimating Handbook",
          "trust": "primary",
          "url": "https://www.nasa.gov/reference/nasa-cost-estimating-handbook/",
          "recordHash": "fnv1a32-a82e1046",
          "queryPolicy": "Document handbook version, estimating method, normalization year, risk treatment, and applied model assumptions.",
          "units": [
            "cost estimate classes",
            "risk",
            "schedule",
            "uncertainty"
          ],
          "uncertaintyMode": "Method selection, analogy quality, learning curves, schedule risk, and normalization assumptions."
        },
        {
          "sourceId": "nasa-se-handbook",
          "title": "NASA Systems Engineering Handbook",
          "trust": "primary",
          "url": "https://www.nasa.gov/reference/systems-engineering-handbook/",
          "recordHash": "fnv1a32-991637e4",
          "queryPolicy": "Document handbook version, review/maturity concept used, and mapping to scenario/process gates.",
          "units": [
            "life-cycle phase",
            "maturity",
            "verification",
            "validation"
          ],
          "uncertaintyMode": "Program-specific tailoring and maturity-assessment subjectivity."
        },
        {
          "sourceId": "usaspending",
          "title": "USAspending.gov",
          "trust": "primary",
          "url": "https://www.usaspending.gov/",
          "recordHash": "fnv1a32-fb43b155",
          "queryPolicy": "Preserve query filters, award id, recipient, agency, obligation amounts, date range, and retrieval hash.",
          "units": [
            "USD",
            "award id",
            "recipient",
            "obligation",
            "period of performance"
          ],
          "uncertaintyMode": "Award modification timing, obligation versus outlay, scope classification, and recipient hierarchy."
        },
        {
          "sourceId": "sec-edgar",
          "title": "SEC EDGAR",
          "trust": "primary",
          "url": "https://www.sec.gov/edgar",
          "recordHash": "fnv1a32-f2e84204",
          "queryPolicy": "Preserve CIK/ticker, accession number, filing date, statement section, XBRL fields, and retrieval hash.",
          "units": [
            "USD",
            "filing date",
            "fiscal period",
            "risk factors"
          ],
          "uncertaintyMode": "Company-specific accounting policy, segment allocation, forward-looking statements, and market-cycle caveats."
        }
      ],
      "snapshotEvidence": [],
      "readinessScore": 54.2,
      "promotionAllowed": false,
      "contractHash": "fnv1a32-83d7b008",
      "generatedHash": "sha256-0299318b126e0f81798b1aff6d51317cb898e50e2c6d1d5fee752d13979849b1"
    }
  ],
  "bundleHash": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030"
}
;
